<template>
  <div
    class="recommend-swiper"
    :class="{borderbox: isBorder == true}"
  >
    <el-carousel
      class="carousel-el pc-margin-bottom30-mobil-margin-bottom20 border-radius5"
      arrow="never"
      :height="carouselHeight"
      v-if="listData.length"
    >
      <el-carousel-item
        v-for="(item,index) in listData"
        :key="index"
      >
        <div class="item-box pr">
          <div class="recommend-tag pa">{{$t('Recommended_traders')}}</div>
          <div class="name-row">
            <span
              @click="detailHandle(item)"
              class="name pointer">{{item.alias}}</span>
            <span
              class="tag-box"
              :style="tagStyle"
            >{{$t('customerHome.MAM_master')}}</span>
          </div>
          <div class="rate-row">
            <el-rate
              size="medium"
              disabled
              :value="item.recommendStar"
              show-score
              :colors="[themeColor,themeColor,themeColor]"
              text-color="#999999"
            ></el-rate>
          </div>
          <el-row>
            <el-col
              :span="12"
              class="col-el"
            >
              <div class="text-box">{{$t('share_rate_of_return')}}</div>
              <div class="data-box theme-green">{{item.profitRate}}</div>
            </el-col>
            <el-col
              :span="12"
              class="col-el"
            >
              <div class="text-box">{{$t('User.totalProfit')}}</div>
              <div class="data-box">{{item.profitAmount}} USD</div>
            </el-col>
            <el-col
              :span="12"
              class="col-el"
            >
              <div class="text-box">{{$t('maximum_drawdown')}}</div>
              <div class="data-box">{{item.maxRetracement}}</div>
            </el-col>
            <el-col
              :span="12"
              class="col-el"
            >
              <div class="text-box">{{$t('Subscribe_to_the_number_of')}}</div>
              <div class="data-box">{{item.subNum}}</div>
            </el-col>
          </el-row>
          <vs-button
            class="vs-button-el"
            @click="copyHandle(item)"
          >{{$t('subscription')}}</vs-button>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { colorRgba } from "@/utils";
import { mapGetters } from 'vuex'
import {queryTopSignal} from "@/api/userCenter";
export default {
  name: "recommendSwiper",
  props: {
    isBorder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      themeGreen: '#41B883',
      listData: []
    };
  },
  created(){
    this.getList();
  },
  computed: {
    ...mapGetters(['realMobile','device','themeColor']),
    carouselHeight(){

      if(this.device == 'mobile'){
        return '338px';
      }else {
        return '338px';
      }
    },
    tagStyle(){
      return {
        backgroundColor: colorRgba(this.themeColor,0.1),
        color: this.themeColor,
      }
    }
  },
  methods: {
    detailHandle(item){
      localStorage.setItem('goBackRouterName','copyMaster');
      this.$router.push({name: 'mamMasterDetails', params: {mtid: item.mtId}});
    },
    getList(){
      queryTopSignal({
        isRecommended: 1,
      }).then((res) => {
        this.listData = res.data;
      });
    },
    copyHandle(signalInfo) {
      // 确认下 signalInfo.mtId 字段 todo
      this.$store.commit('setCurrentMasterMtId', signalInfo.mtId);

      this.$store.commit('setMamSubscrpitDialogShow',true);
    },
  }
}
</script>

<style lang="scss">
@import "../../../assets/scss/variable";
.recommend-swiper {
  background-color: #ffffff;
  border-radius: 6px;
  .carousel-el {
    .theme-green {
      color: $themeGreen;
    }
    .el-carousel__indicator {
      .el-carousel__button {
        width: 10px;
        height: 10px;
        background-color: #E6E6E6;
        border-radius: 50%;
      }
      &.is-active .el-carousel__button {
        background-color: $themeColor;
      }
    }
    .el-carousel__arrow {
      background-color: rgba(0,0,0, 0.6);
    }
    .item-box {
      padding: 24px;
    }
  }
}
</style>
<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.recommend-swiper {
  .item-box {
    padding-top: 36px;
    overflow: hidden;
    .recommend-tag {
      top: 0;
      left: 0;
      height: 26px;
      line-height: 26px;
      padding: 0 10px;
      text-align: center;
      background-color: $themeGreen;
      color: #ffffff;
      border-top-left-radius: 6px;
      border-bottom-right-radius: 6px;
    }
    .name-row {
      .name {
        font-weight: 600;
        font-size: 16px;
      }
      .tag-box {
        display: inline-block;
        padding: 4px 8px;
        border-radius: 15px;
        margin-left: 10px;
      }
    }
    .rate-row {
      margin-top: 10px;
      margin-bottom: 20px;
    }
    .data-box {
      font-size: 16px;
      font-weight: 500;
      color: #5E5873;
    }
    .text-box {
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 5px;
      color: #6E6B7B;
    }
    .col-el {
      margin-bottom: 20px;
    }
    .theme-green {
      color: $themeGreen;
    }
    .vs-button-el {
      width: 100%;
      margin-bottom: 20px;
    }
  }
  &.borderbox {
    border: 1px solid #EBE9F1;
    border-radius: 6px;
  }
}
</style>
